import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ActivityItemsQuery as ActivityItemsQueryType,
  ActivityItemsQueryVariables,
} from "./__generated__/ActivityItemsQuery";

const ActivityItemsQuery = loader("./ActivityItemsQuery.gql");

type ActivityItemsQueryProviderType = (props: {
  children: (data: ActivityItemsQueryType) => ReactNode;
  variables: ActivityItemsQueryVariables;
}) => ReactElement;

export const ActivityItemsQueryProvider: ActivityItemsQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<ActivityItemsQueryType, ActivityItemsQueryVariables>(ActivityItemsQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
